import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  tone?: 'lime' | 'white' | 'blue';
  className?: string;
}
const toneStyles: Record<string, string> = {
  lime: 'text-mp-lime border-mp-lime/40 bg-mp-lime/5',
  white: 'text-mp-white border-mp-border bg-white/5',
  blue: 'text-mp-electric border-mp-electric/40 bg-mp-electric/5'
};
export function SectionTag({
  children,
  tone = 'lime',
  className = ''
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 font-heading text-[11px] md:text-xs font-medium uppercase tracking-[0.18em] ${toneStyles[tone]} ${className}`} data-id="element-354" data-mp="h0rjfle2bcy">
      <span className="h-1.5 w-1.5 rounded-full bg-current" data-id="element-355" data-mp="aex7qlt6nwhx" />
      {children}
    </span>;
}